// extracted by mini-css-extract-plugin
module.exports = {"cut":"wire-sequences_cut__1goiG"};